"use client";

export default function Dialog({ 
  isOpen, 
  onClose, 
  title, 
  children,
  className = ""
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-30" onClick={onClose} />
      <div className={`relative bg-white rounded-2xl shadow-lg w-11/12 max-w-md text-center max-h-[80vh] flex flex-col ${className}`}>
        <div className="text-xl font-bold mb-2 p-6 pb-2 flex-shrink-0 whitespace-pre-wrap">{title}</div>
        <div className="px-6 pb-6 overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );
}

export function DialogButton({ 
  children, 
  onClick, 
  variant = "default",
  className = ""
}) {
  const baseClasses = "w-full py-4 text-xl focus:outline-none transition-all duration-200 hover:bg-blue-100 cursor-pointer";
  const variantClasses = {
    default: "text-blue-500 font-medium hover:text-blue-600",
    primary: "text-blue-500 font-medium hover:text-blue-600",
    cancel: "text-blue-500 font-bold hover:text-blue-600 hover:bg-gray-200"
  };

  return (
    <>
      <div className="border-t bg-gray-400" />
      <button 
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    </>
  );
}
